"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
exports.default = satcheljs_1.mutatorAction('discardKeyboardShortcutsOption', function discardKeyboardShortcutsOption() {
    var optionState = store_1.default();
    optionState.shortcuts = null;
});
//# sourceMappingURL=discardKeyboardShortcutsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/data/mutators/discardKeyboardShortcutsOption.js
// module id = 4974
// module chunks = 2